import {v} from "@angular/core/src/render3";

export class ChartPeriodSelector{
    constructor(

    ){

    }

    public stQuarter: boolean;
    public ndQuarter: boolean;
    public rdQuarter: boolean;
    public thQuarter: boolean;
    public stHalfYear: boolean;
    public ndHalfYear: boolean;

    public readonly setData = (month: number): void => {
        if (month < 3){
            this.stQuarter = true;
            this.ndQuarter = false;
            this.rdQuarter = false;
            this.thQuarter = false;
            this.stHalfYear = true;
            this.ndHalfYear = false;
        } else if (month < 6){
            this.stQuarter = true;
            this.ndQuarter = true;
            this.rdQuarter = false;
            this.thQuarter = false;
            this.stHalfYear = true;
            this.ndHalfYear = false;
        } else if (month < 9){
            this.stQuarter = true;
            this.ndQuarter = true;
            this.rdQuarter = true;
            this.thQuarter = false;
            this.stHalfYear = true;
            this.ndHalfYear = true;
        } else if (month <= 11){
            this.stQuarter = true;
            this.ndQuarter = true;
            this.rdQuarter = true;
            this.thQuarter = true;
            this.stHalfYear = true;
            this.ndHalfYear = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-period-selector.ts